/* faq
========================================================*/
export function initfaqFunctions() {

  document.addEventListener('DOMContentLoaded', () => {
    const faqTriggers = document.querySelectorAll('.js-faq-trigger');

    const toggleFaq = (trigger) => {
      const parent = trigger.closest('.js-faq-item');
      const answer = parent.querySelector('.modListFaq__answer');
      const isActive = parent.classList.contains('is-active');

      if (isActive) {
        parent.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
        answer.setAttribute('aria-hidden', 'true');
        answer.style.height = '0px';
      } else {
        parent.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        answer.setAttribute('aria-hidden', 'false');
        answer.style.height = answer.scrollHeight + 'px';
      }
    };

    faqTriggers.forEach(trigger => {
      // クリックイベント
      trigger.addEventListener('click', () => toggleFaq(trigger));

      // キーボード操作対応 (Enterキー)
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          toggleFaq(trigger);
        }
      });
    });
  });

}